import { Moment } from "moment";
import { ReportePedidos } from "../types/reporte-pedidos.type";
import ApiService from "./apiService";
import { formatFromAndTo } from "../utils/dateUtils";
import { ReporteCadetes } from "../types/reporte-cadetes";

const endpoint = "/api/v1/negocios/reportes";

export class ReportesService extends ApiService {
  getReportePedidos(from: Moment, to: Moment) {
    const { from: desde, to: hasta } = formatFromAndTo(from, to);
    return this.post<ReportePedidos>(
      `${endpoint}/pedidos/`,
      { desde, hasta },
      {
        negocioActivo: true,
      }
    );
  }

  getReporteCadetes(from: Moment, to: Moment) {
    return this.post<ReporteCadetes>(
      `${endpoint}/cadetes/`,
      {
        desde: from.format("YYYY-MM-DD").concat("T00:00:00"),
        hasta: to.format("YYYY-MM-DD").concat("T23:59:59"),
      },
      {
        negocioActivo: true,
      }
    );
  }
}

const reportesService = new ReportesService();
export default reportesService;
